import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useMCPServers } from "@/hooks/useMCPServers";
import { useEffect, useRef } from "react";
import MCPStore from "./MCPStore";

export default function MCPStoreModal() {
  const { isModalOpen, closeModal, fetchServers } = useMCPServers();
  const hasFetchedRef = useRef(false);

  // Fetch servers only once when modal opens for the first time
  useEffect(() => {
    if (isModalOpen && !hasFetchedRef.current) {
      fetchServers();
      hasFetchedRef.current = true;
    }
  }, [isModalOpen, fetchServers]);

  return (
    <Dialog open={isModalOpen} onOpenChange={closeModal}>
      <DialogContent className="max-w-[900px] h-[700px] p-0 overflow-hidden">
        <MCPStore />
      </DialogContent>
    </Dialog>
  );
}
